import React, { useState, useRef } from 'react';
import { Button, TextInput, Popover } from '..';
import { chevronIcon } from './functions/icons';
import { isValidTimeFormat, isValidTime, isCompletedTimeFormat } from './functions/helper';
import { useEffectAfterMount } from '../../utils/hooks';
export const TimeRangeSelector = ({ fromInputValue, toInputValue, setInputValue, fromTime, toTime, setTime, languageData, }) => {
    const lastFromValue = useRef('');
    const lastToValue = useRef('');
    const [fromValid, setFromValid] = useState(true);
    const [toValid, setToValid] = useState(true);
    const isValid = fromValid && toValid;
    const [isOpen, setIsOpen] = useState(false);
    useEffectAfterMount(() => {
        // Send back the newest 'completed' times
        if (isValidTime(fromInputValue)) {
            setTime(fromInputValue, 'from');
        }
        if (isValidTime(toInputValue)) {
            setTime(toInputValue, 'to');
        }
        // Check validity
        if (!fromInputValue && !toInputValue) {
            setFromValid(true);
            setToValid(true);
        }
        else {
            if (isCompletedTimeFormat(fromInputValue)) {
                setFromValid(isValidTime(fromInputValue));
            }
            if (isCompletedTimeFormat(toInputValue)) {
                setToValid(isValidTime(toInputValue));
            }
        }
    }, [fromInputValue, toInputValue]);
    const onValueChange = (value, type) => {
        const lastValue = type === 'from' ? lastFromValue.current : lastToValue.current;
        if (isValidTimeFormat(value)) {
            // Add or remove the colon as required
            if (value.length === 2 && lastValue.length !== 3 && value.indexOf(':') === -1) {
                value = value + ':';
            }
            if (value.length === 2 && lastValue.length === 3) {
                value = value.slice(0, 1);
            }
            if (value.length <= 5) {
                if (type === 'from') {
                    lastFromValue.current = value;
                    setInputValue(value, 'from');
                }
                else {
                    lastToValue.current = value;
                    setInputValue(value, 'to');
                }
            }
        }
    };
    const getTimeRangeString = () => {
        if (fromTime || toTime) {
            const timeString = `${fromTime}-${toTime}`;
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "time-selector_button--title" },
                    languageData.buttonTitle,
                    ": "),
                React.createElement("span", { className: "time-selector_button--items" }, timeString)));
        }
        return React.createElement("span", { className: "time-selector_button--title" }, languageData.buttonTitle);
    };
    const getErrorText = () => {
        return !isValid ? languageData.validationError : '';
    };
    const handlePopOverToggle = () => {
        if (!isOpen) {
            setIsOpen(true);
        }
    };
    const handlePopOverClose = () => {
        if (!fromInputValue && toInputValue) {
            setFromValid(false);
        }
        else if (!toInputValue && fromInputValue) {
            setToValid(false);
        }
        if ((isValid && isCompletedTimeFormat(fromInputValue) && isCompletedTimeFormat(toInputValue)) ||
            (!fromInputValue && !toInputValue)) {
            setIsOpen(false);
        }
        else {
            setIsOpen(true);
        }
    };
    return (React.createElement(Popover, { position: "bottom-left", transitionDuration: 0, onInteraction: () => handlePopOverToggle(), onClose: () => handlePopOverClose(), isOpen: isOpen, autoFocus: false },
        React.createElement(Button, { className: "time-selector_button--category", style: "subtle", rightIcon: chevronIcon }, getTimeRangeString()),
        React.createElement("div", { className: "filter-popover-content" },
            React.createElement("section", { className: "time-selector-container" },
                React.createElement(TextInput, { className: "time-selector", value: fromInputValue, state: fromValid ? 'default' : 'error', "aria-label": 'from time ', "aria-atomic": "true", onBlur: () => {
                        isCompletedTimeFormat(fromInputValue)
                            ? setFromValid(isValidTime(fromInputValue))
                            : !toInputValue
                                ? setFromValid(true)
                                : setFromValid(false);
                    }, onChange: (e) => onValueChange(e.target.value, 'from'), placeholder: `hh:mm`, autoFocus: true }),
                React.createElement("div", { className: "time-selector-to" }, "to"),
                React.createElement(TextInput, { className: "time-selector", value: toInputValue, state: toValid ? 'default' : 'error', "aria-label": 'to time ', "aria-atomic": "true", onBlur: () => {
                        isCompletedTimeFormat(toInputValue)
                            ? setToValid(isValidTime(toInputValue))
                            : !fromInputValue
                                ? setToValid(true)
                                : setToValid(false);
                    }, onChange: (e) => onValueChange(e.target.value, 'to'), placeholder: `hh:mm` })),
            React.createElement("div", { className: "time-selector-error" }, getErrorText()))));
};
//# sourceMappingURL=TimeRangeSelector.js.map